/**
 * @deprecated
 * Includes are deprecated. See IMP-1330
 */
export enum INTERVENTION_TEMPLATE_INCLUDES {
  REVISION = "revisions",
  REFERENCE_REVISION = "reference.revisions",
}
